/**
 * Route for `igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelinePage } from "../features/igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline/IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelinePage";

export const igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline",
	component: IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelinePage,
});

export default igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRoute;
